export default "__VITE_ASSET__BzvPY7V7__"